<template>
  <div class="beer-style-guide-component">
    <h5 class="style-name">{{recipe.subStyle}}
      <small><a href="#"
                class="btn btn-secondary btn-sm beer-sub-style-trigger"
                v-if="loggedIn"
                @click.prevent="showBeerSubStyleModal=true">Edit</a></small>
    </h5>
    <BrewStyleSlider
      :beerSubStyleId="beerSubStyleId"
      :recipe="recipe"></BrewStyleSlider>

    <BrewStylesModal
      v-if="showBeerSubStyleModal"
      v-on:close-modal="showBeerSubStyleModal = false"
      v-on:update-beer-sub-style-id="updateBeerSubStyleId"
      :styleId="recipe.beerSubStyleId"
      :recipe-url="recipeUrl"></BrewStylesModal>
  </div>
</template>

<script>
    import BrewStylesModal from "../components/modals/BrewStylesModal";
    import RecipeValues from "../components/RecipeValues";
    import BrewStyleSlider from "../components/BeerStyleSlider";
    import { EventBus } from '../lib/event-bus.js';

    export default {
        components: {
            BrewStylesModal,
            BrewStyleSlider,
            RecipeValues
        },
        props: {
            name: String,
            recipeUrl: String,
            recipe: {
                type: Object
            }
        },
        data() {
            return {
                errors: null,
                loading: false,
                loggedIn: true,
                beerSubStyleId: null,
                showBeerSubStyleModal: false
            };
        },
        methods: {
            updateBeerSubStyleId(styleId) {
                this.beerSubStyleId = styleId;
            }
        },

        beforeMount() {
            this.beerSubStyleId = this.recipe.beerSubStyleId;
            this.loggedIn = !!localStorage.username;
            EventBus.$on('logged-in', val => { this.loggedIn = val; });
        },
    };
</script>

<style scoped lang="scss">
  $outer-padding: 20px;

  .beer-style-guide-component {
    .style-name { padding-right: 2em; }

    .beer-sub-style-trigger {
      position: absolute;
      top: $outer-padding;
      font-size: .7em;
      right: $outer-padding;
    }

  }
</style>
